import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const isOpen = index !== null && index !== undefined;

  const handleKey = useCallback(
    (e) => {
      if (!isOpen) return;
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [isOpen, onClose, onPrev, onNext]
  );

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", handleKey);
    };
  }, [isOpen, handleKey]);

  if (!isOpen) return null;
  const src = images[index];
  if (!src) return null;

  return (
    <div
      data-testid="lightbox"
      onClick={onClose}
      className="fixed inset-0 z-[100] bg-[#0E0C09]/95 flex items-center justify-center p-4 md:p-12 fade-up"
      style={{ animationDuration: "0.4s" }}
    >
      <button
        onClick={onClose}
        aria-label="Close"
        data-testid="lightbox-close"
        className="absolute top-6 right-6 text-[#FDFBF7]/80 hover:text-[#FDFBF7] z-10"
      >
        <X size={28} />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        aria-label="Previous"
        data-testid="lightbox-prev"
        className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 text-[#FDFBF7]/80 hover:text-[#FDFBF7]"
      >
        <ChevronLeft size={42} />
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        aria-label="Next"
        data-testid="lightbox-next"
        className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 text-[#FDFBF7]/80 hover:text-[#FDFBF7]"
      >
        <ChevronRight size={42} />
      </button>
      <img
        src={src}
        alt=""
        onClick={(e) => e.stopPropagation()}
        className="max-h-full max-w-full object-contain"
      />
      <div className="absolute bottom-6 left-0 right-0 text-center font-mono-accent text-[10px] text-[#FDFBF7]/60">
        {index + 1} / {images.length}
      </div>
    </div>
  );
}
